import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { ExclusionContainer } from '../../components/resources/ExclusionContainer';

const ExclusionsPage: React.FC = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.role?.viewResource) navigate('/');
  }, [me, me?.role?.viewResource, navigate])

  return <ExclusionContainer />;
};

export default ExclusionsPage;
